export const updateMilestoneCompletionProperties = (
  milestones,
  shouldCompleteProjectMilestoneTemplate
) => {
  const shouldCompleteProjectMilestoneTemplateId =
    shouldCompleteProjectMilestoneTemplate.new?.id ||
    shouldCompleteProjectMilestoneTemplate.current?.id;

  if (!milestones) return;

  const recursivelyIterate = (milestones) => {
    milestones.forEach((milestone) => {
      const shouldCompleteProject =
        shouldCompleteProjectMilestoneTemplateId === milestone.id;

      milestone.shouldCompleteProject = shouldCompleteProject;
      milestone.secureProjectOnCompletion = shouldCompleteProject
        ? milestone.secureProjectOnCompletion || false
        : false;

      if (milestone.childMilestones)
        recursivelyIterate(milestone.childMilestones);
    });
  };

  recursivelyIterate(milestones);
};
